<script lang="ts">
    import Availability from '../availability/Availability.svelte';
    import OttoUp from '../otto-up/OttoUp.svelte';

    interface Props {
        availabilityText: string | null | undefined;
        ottoUp: boolean | undefined;
    }

    let { availabilityText, ottoUp }: Props = $props();
</script>

{#if availabilityText || ottoUp}
    <div class="reptile-availability">
        <Availability text={availabilityText} />
        <OttoUp show={ottoUp} />
    </div>
{/if}

<style lang="scss">
    @use '@otto-ec/design-tokens/tokens';

    .reptile-availability {
        display: flex;
        flex-wrap: wrap;
        gap: tokens.$oc-semantic-spacing-50;
        align-items: center;
        justify-content: space-between;

        width: 100%;
    }
</style>
